import { useLocation, useSearchParams } from "react-router-dom";
import { BankTransactions } from "@/components/bank-transactions.jsx";

export default function TransactionsBancaires() {
  const location = useLocation();
  const [searchParams] = useSearchParams();

  // Get clientID from navigation state or URL params
  const companyId = location.state?.companyId || searchParams.get("companyId");

  return (
    <div className="p-6 space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">
          Transactions Bancaires
        </h1>
        <p className="text-muted-foreground mt-2">
          Gérez les relevés bancaires et analysez les transactions
        </p>
      </div>
      
      <BankTransactions companyId={companyId} />
    </div>
  );
}
